import type { RootState } from "@src/store/rootState";
import { getVariationDraft } from "@src/store/slices/experienceBuilder/basicMod/selectors/getVariationDraft";

export function canSwapMods(state: RootState) {
  const mod = getVariationDraft(state);
  return mod && "nodes" in mod && mod.nodes.length > 1;
}
